import axios from 'axios';
import useStore from '../store/useStore';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const PUBLIC_PATHS = [
  '/auth/login',
  '/auth/signup',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/logout',
  '/contact',
  '/subscription-plans/public'
];

// Request interceptor: attach the saved JWT to every authenticated request.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Let the browser set multipart boundaries for file uploads.
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: send expired sessions to login.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    const isPublicRequest = PUBLIC_PATHS.some((path) => requestUrl.includes(path));
    const isAuthMeRequest = requestUrl.includes('/auth/me');

    if (error.response?.status === 401 && !isPublicRequest) {
      localStorage.removeItem('token');
      useStore.getState().logout();

      if (!isAuthMeRequest) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
